//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';
import authService, { AuthorizeService } from "../components/api-authorization/AuthorizeService";
import { AccountLevel, ClaimActionType, ClaimScope } from '../config/Levels'
import { ISystemSettings, SystemSettings } from './class_extensions';
import { Config } from "../config/Config";
import dayjs from 'dayjs';
export class AuthorizedApiBase {
    private authService: AuthorizeService;

    protected constructor() {
        this.authService = authService;
    }

    protected transformOptions = async (options: MyAxiosRequestConfig): Promise<MyAxiosRequestConfig> => {
        options.headers = {
            ...options.headers,
            Authorization: 'Bearer ' + await this.authService.getAccessToken()
        };
        return Promise.resolve(options);
    };

    protected getBaseUrl(baseUrl: string) {
        return `${Config.server_url}:${Config.port}`;
    }
}

export class ClientConfigClient extends AuthorizedApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @return Success
     */
    clientConfig(  cancelToken?: CancelToken | undefined): Promise<ConfigResponse> {
        let url_ = this.baseUrl + "/api/ClientConfig";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processClientConfig(_response);
        });
    }

    protected processClientConfig(response: AxiosResponse): Promise<ConfigResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ConfigResponse.fromJS(resultData200);
            return Promise.resolve<ConfigResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ConfigResponse>(null as any);
    }
}

export class KrestonClient extends AuthorizedApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * (Auth policies: IsOwnerOrAbove)
     * @return Success
     */
    approvalStatus(partnerId: string , cancelToken?: CancelToken | undefined): Promise<PartnersApprovals[]> {
        let url_ = this.baseUrl + "/api/v2/Kreston/ApprovalStatus/{partnerId}";
        if (partnerId === undefined || partnerId === null)
            throw new Error("The parameter 'partnerId' must be defined.");
        url_ = url_.replace("{partnerId}", encodeURIComponent("" + partnerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApprovalStatus(_response);
        });
    }

    protected processApprovalStatus(response: AxiosResponse): Promise<PartnersApprovals[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PartnersApprovals.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PartnersApprovals[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PartnersApprovals[]>(null as any);
    }

    /**
     * (Auth policies: IsOwnerOrAbove)
     * @param body (optional) 
     * @return Success
     */
    createKdFiscalYear(body?: CreateKdFiscalYearRequest | undefined , cancelToken?: CancelToken | undefined): Promise<CreateOrganizationResponse> {
        let url_ = this.baseUrl + "/api/v2/Kreston/CreateKdFiscalYear";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateKdFiscalYear(_response);
        });
    }

    protected processCreateKdFiscalYear(response: AxiosResponse): Promise<CreateOrganizationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateOrganizationResponse.fromJS(resultData200);
            return Promise.resolve<CreateOrganizationResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateOrganizationResponse>(null as any);
    }

    /**
     * (Auth policies: IsOwnerOrAbove)
     * @return Success
     */
    projectsStatus(partnerId: string , cancelToken?: CancelToken | undefined): Promise<ProjectStatusResponse[]> {
        let url_ = this.baseUrl + "/api/v2/Kreston/ProjectsStatus/{partnerId}";
        if (partnerId === undefined || partnerId === null)
            throw new Error("The parameter 'partnerId' must be defined.");
        url_ = url_.replace("{partnerId}", encodeURIComponent("" + partnerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processProjectsStatus(_response);
        });
    }

    protected processProjectsStatus(response: AxiosResponse): Promise<ProjectStatusResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Server Error", status, _responseText, _headers, result500);

        } else if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectStatusResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProjectStatusResponse[]>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectStatusResponse[]>(null as any);
    }
}

export enum ApprovalFlowStatus {
    _0 = 0,
    _1001 = 1001,
    _1002 = 1002,
    _1003 = 1003,
    _1004 = 1004,
    _1005 = 1005,
    _2002 = 2002,
    _2003 = 2003,
    _2004 = 2004,
}

export class ApprovalStepDetail implements IApprovalStepDetail {
    name!: string | undefined;
    description!: string | undefined;
    commentOnApprove!: boolean;
    commentOnReject!: boolean;
    autoApproveForTriggerer!: boolean;

    constructor(data?: IApprovalStepDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.commentOnApprove = _data["commentOnApprove"];
            this.commentOnReject = _data["commentOnReject"];
            this.autoApproveForTriggerer = _data["autoApproveForTriggerer"];
        }
    }

    static fromJS(data: any): ApprovalStepDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ApprovalStepDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["commentOnApprove"] = this.commentOnApprove;
        data["commentOnReject"] = this.commentOnReject;
        data["autoApproveForTriggerer"] = this.autoApproveForTriggerer;
        return data;
    }
}

export interface IApprovalStepDetail {
    name: string | undefined;
    description: string | undefined;
    commentOnApprove: boolean;
    commentOnReject: boolean;
    autoApproveForTriggerer: boolean;
}

export class ConfigResponse implements IConfigResponse {
    appInsightsConnString!: string | undefined;

    constructor(data?: IConfigResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appInsightsConnString = _data["appInsightsConnString"];
        }
    }

    static fromJS(data: any): ConfigResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ConfigResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appInsightsConnString"] = this.appInsightsConnString;
        return data;
    }
}

export interface IConfigResponse {
    appInsightsConnString: string | undefined;
}

export class CreateKdFiscalYearRequest implements ICreateKdFiscalYearRequest {
    originProjectId!: string;
    templateProjectId!: string;
    fiscalYear!: string | undefined;
    copyTeams!: boolean;
    copyUsers!: boolean;
    copyRegnskabsElementer!: boolean;
    copyQuestionAnswers!: boolean;
    copyDifferencer!: boolean;
    copyNotes!: boolean;

    constructor(data?: ICreateKdFiscalYearRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originProjectId = _data["originProjectId"];
            this.templateProjectId = _data["templateProjectId"];
            this.fiscalYear = _data["fiscalYear"];
            this.copyTeams = _data["copyTeams"];
            this.copyUsers = _data["copyUsers"];
            this.copyRegnskabsElementer = _data["copyRegnskabsElementer"];
            this.copyQuestionAnswers = _data["copyQuestionAnswers"];
            this.copyDifferencer = _data["copyDifferencer"];
            this.copyNotes = _data["copyNotes"];
        }
    }

    static fromJS(data: any): CreateKdFiscalYearRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateKdFiscalYearRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originProjectId"] = this.originProjectId;
        data["templateProjectId"] = this.templateProjectId;
        data["fiscalYear"] = this.fiscalYear;
        data["copyTeams"] = this.copyTeams;
        data["copyUsers"] = this.copyUsers;
        data["copyRegnskabsElementer"] = this.copyRegnskabsElementer;
        data["copyQuestionAnswers"] = this.copyQuestionAnswers;
        data["copyDifferencer"] = this.copyDifferencer;
        data["copyNotes"] = this.copyNotes;
        return data;
    }
}

export interface ICreateKdFiscalYearRequest {
    originProjectId: string;
    templateProjectId: string;
    fiscalYear: string | undefined;
    copyTeams: boolean;
    copyUsers: boolean;
    copyRegnskabsElementer: boolean;
    copyQuestionAnswers: boolean;
    copyDifferencer: boolean;
    copyNotes: boolean;
}

export class CreateOrganizationResponse implements ICreateOrganizationResponse {
    id!: string;

    constructor(data?: ICreateOrganizationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): CreateOrganizationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrganizationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface ICreateOrganizationResponse {
    id: string;
}

export class PartnersApprovals implements IPartnersApprovals {
    organizationName!: string | undefined;
    fiscalYear!: string | undefined;
    id!: string;
    userId!: string;
    approvalFlowState!: number;
    regardingObjectType!: string | undefined;
    regardingObjectTypeId!: string;
    regardingObject!: string | undefined;
    regardingObjectId!: string;
    triggerTime!: dayjs.Dayjs;
    time!: string | undefined;
    comments!: string | undefined;
    userName!: string | undefined;
    updatedAtTime!: dayjs.Dayjs;
    updateTime!: string | undefined;
    wizardId!: string | undefined;
    flowEngineStepId!: string | undefined;
    flowEngineStepName!: string | undefined;
    dataVersion!: string | undefined;
    approvalStepDetails!: ApprovalStepDetail;
    flowEngineHistoryLogId!: string;
    icon!: string | undefined;
    commentOnApprove!: boolean;
    commentOnReject!: boolean;
    autoApproveForTriggerer!: boolean;
    flowEngineID!: string;
    organizationId!: string;

    constructor(data?: IPartnersApprovals) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.organizationName = _data["organizationName"];
            this.fiscalYear = _data["fiscalYear"];
            this.id = _data["id"];
            this.userId = _data["userId"];
            this.approvalFlowState = _data["approvalFlowState"];
            this.regardingObjectType = _data["regardingObjectType"];
            this.regardingObjectTypeId = _data["regardingObjectTypeId"];
            this.regardingObject = _data["regardingObject"];
            this.regardingObjectId = _data["regardingObjectId"];
            this.triggerTime = _data["triggerTime"] ? dayjs(_data["triggerTime"].toString()) : <any>undefined;
            this.time = _data["time"];
            this.comments = _data["comments"];
            this.userName = _data["userName"];
            this.updatedAtTime = _data["updatedAtTime"] ? dayjs(_data["updatedAtTime"].toString()) : <any>undefined;
            this.updateTime = _data["updateTime"];
            this.wizardId = _data["wizardId"];
            this.flowEngineStepId = _data["flowEngineStepId"];
            this.flowEngineStepName = _data["flowEngineStepName"];
            this.dataVersion = _data["dataVersion"];
            this.approvalStepDetails = _data["approvalStepDetails"] ? ApprovalStepDetail.fromJS(_data["approvalStepDetails"]) : <any>undefined;
            this.flowEngineHistoryLogId = _data["flowEngineHistoryLogId"];
            this.icon = _data["icon"];
            this.commentOnApprove = _data["commentOnApprove"];
            this.commentOnReject = _data["commentOnReject"];
            this.autoApproveForTriggerer = _data["autoApproveForTriggerer"];
            this.flowEngineID = _data["flowEngineID"];
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): PartnersApprovals {
        data = typeof data === 'object' ? data : {};
        let result = new PartnersApprovals();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["organizationName"] = this.organizationName;
        data["fiscalYear"] = this.fiscalYear;
        data["id"] = this.id;
        data["userId"] = this.userId;
        data["approvalFlowState"] = this.approvalFlowState;
        data["regardingObjectType"] = this.regardingObjectType;
        data["regardingObjectTypeId"] = this.regardingObjectTypeId;
        data["regardingObject"] = this.regardingObject;
        data["regardingObjectId"] = this.regardingObjectId;
        data["triggerTime"] = this.triggerTime ? this.triggerTime.toISOString() : <any>undefined;
        data["time"] = this.time;
        data["comments"] = this.comments;
        data["userName"] = this.userName;
        data["updatedAtTime"] = this.updatedAtTime ? this.updatedAtTime.toISOString() : <any>undefined;
        data["updateTime"] = this.updateTime;
        data["wizardId"] = this.wizardId;
        data["flowEngineStepId"] = this.flowEngineStepId;
        data["flowEngineStepName"] = this.flowEngineStepName;
        data["dataVersion"] = this.dataVersion;
        data["approvalStepDetails"] = this.approvalStepDetails ? this.approvalStepDetails.toJSON() : <any>undefined;
        data["flowEngineHistoryLogId"] = this.flowEngineHistoryLogId;
        data["icon"] = this.icon;
        data["commentOnApprove"] = this.commentOnApprove;
        data["commentOnReject"] = this.commentOnReject;
        data["autoApproveForTriggerer"] = this.autoApproveForTriggerer;
        data["flowEngineID"] = this.flowEngineID;
        data["organizationId"] = this.organizationId;
        return data;
    }
}

export interface IPartnersApprovals {
    organizationName: string | undefined;
    fiscalYear: string | undefined;
    id: string;
    userId: string;
    approvalFlowState: number;
    regardingObjectType: string | undefined;
    regardingObjectTypeId: string;
    regardingObject: string | undefined;
    regardingObjectId: string;
    triggerTime: dayjs.Dayjs;
    time: string | undefined;
    comments: string | undefined;
    userName: string | undefined;
    updatedAtTime: dayjs.Dayjs;
    updateTime: string | undefined;
    wizardId: string | undefined;
    flowEngineStepId: string | undefined;
    flowEngineStepName: string | undefined;
    dataVersion: string | undefined;
    approvalStepDetails: ApprovalStepDetail;
    flowEngineHistoryLogId: string;
    icon: string | undefined;
    commentOnApprove: boolean;
    commentOnReject: boolean;
    autoApproveForTriggerer: boolean;
    flowEngineID: string;
    organizationId: string;
}

export class ProblemDetails implements IProblemDetails {
    type!: string | undefined;
    title!: string | undefined;
    status!: number | undefined;
    detail!: string | undefined;
    instance!: string | undefined;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type: string | undefined;
    title: string | undefined;
    status: number | undefined;
    detail: string | undefined;
    instance: string | undefined;
}

export class ProjectStatusResponse implements IProjectStatusResponse {
    id!: string;
    name!: string | undefined;
    fiscalYear!: string | undefined;
    processes!: SlimProcessWithAnswers[] | undefined;

    constructor(data?: IProjectStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.fiscalYear = _data["fiscalYear"];
            if (Array.isArray(_data["processes"])) {
                this.processes = [] as any;
                for (let item of _data["processes"])
                    this.processes!.push(SlimProcessWithAnswers.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["fiscalYear"] = this.fiscalYear;
        if (Array.isArray(this.processes)) {
            data["processes"] = [];
            for (let item of this.processes)
                data["processes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProjectStatusResponse {
    id: string;
    name: string | undefined;
    fiscalYear: string | undefined;
    processes: SlimProcessWithAnswers[] | undefined;
}

export class SlimAnswer implements ISlimAnswer {
    questionId!: string;
    answer!: string | undefined;
    validated!: boolean;

    constructor(data?: ISlimAnswer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.questionId = _data["questionId"];
            this.answer = _data["answer"];
            this.validated = _data["validated"];
        }
    }

    static fromJS(data: any): SlimAnswer {
        data = typeof data === 'object' ? data : {};
        let result = new SlimAnswer();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["questionId"] = this.questionId;
        data["answer"] = this.answer;
        data["validated"] = this.validated;
        return data;
    }
}

export interface ISlimAnswer {
    questionId: string;
    answer: string | undefined;
    validated: boolean;
}

export class SlimProcessWithAnswers implements ISlimProcessWithAnswers {
    id!: string;
    organizationId!: string;
    name!: string | undefined;
    lock!: boolean;
    approvalStatus!: ApprovalFlowStatus;
    modifiedOn!: dayjs.Dayjs | undefined;
    approvalFlowState!: dayjs.Dayjs | undefined;
    flowEngineHistoryLogState!: dayjs.Dayjs | undefined;
    questionAnswers!: SlimAnswer[] | undefined;

    constructor(data?: ISlimProcessWithAnswers) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.organizationId = _data["organizationId"];
            this.name = _data["name"];
            this.lock = _data["lock"];
            this.approvalStatus = _data["approvalStatus"];
            this.modifiedOn = _data["modifiedOn"] ? dayjs(_data["modifiedOn"].toString()) : <any>undefined;
            this.approvalFlowState = _data["approvalFlowState"] ? dayjs(_data["approvalFlowState"].toString()) : <any>undefined;
            this.flowEngineHistoryLogState = _data["flowEngineHistoryLogState"] ? dayjs(_data["flowEngineHistoryLogState"].toString()) : <any>undefined;
            if (Array.isArray(_data["questionAnswers"])) {
                this.questionAnswers = [] as any;
                for (let item of _data["questionAnswers"])
                    this.questionAnswers!.push(SlimAnswer.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SlimProcessWithAnswers {
        data = typeof data === 'object' ? data : {};
        let result = new SlimProcessWithAnswers();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["organizationId"] = this.organizationId;
        data["name"] = this.name;
        data["lock"] = this.lock;
        data["approvalStatus"] = this.approvalStatus;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["approvalFlowState"] = this.approvalFlowState ? this.approvalFlowState.toISOString() : <any>undefined;
        data["flowEngineHistoryLogState"] = this.flowEngineHistoryLogState ? this.flowEngineHistoryLogState.toISOString() : <any>undefined;
        if (Array.isArray(this.questionAnswers)) {
            data["questionAnswers"] = [];
            for (let item of this.questionAnswers)
                data["questionAnswers"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISlimProcessWithAnswers {
    id: string;
    organizationId: string;
    name: string | undefined;
    lock: boolean;
    approvalStatus: ApprovalFlowStatus;
    modifiedOn: dayjs.Dayjs | undefined;
    approvalFlowState: dayjs.Dayjs | undefined;
    flowEngineHistoryLogState: dayjs.Dayjs | undefined;
    questionAnswers: SlimAnswer[] | undefined;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}

interface MyAxiosRequestConfig extends Omit<AxiosRequestConfig, "headers"> {
    headers?: any; // this was "any" at v0.21.1 but now broken between 0.21.4 >= 0.27.2
        // Lets make it any again to make it work again.
}